import PropTypes from 'prop-types';
import styled from '@happymoneyinc/styled-components';
import { meta } from '@happymoneyinc/meta';
import { jsx } from 'react/jsx-runtime';
import SvgIcon from '../SvgIcon/SvgIcon.js';

const getRewardPosition = rateRewardPosition => {
  // Can't be less than 0% and default value for Rate Reward Icon position is equal 95
  if (rateRewardPosition < 0 || Number.isNaN(rateRewardPosition)) return 95;
  // Can't be more than 100%
  if (rateRewardPosition > 100) return 100;
  return rateRewardPosition;
};
const RateReward = props => {
  var _meta$colors;
  const {
    hideRateReward,
    isReceivingRateReward,
    rateRewardPosition,
    testID
  } = props;
  if (hideRateReward) return null;
  return /*#__PURE__*/jsx(RateRewardSvgIconContainer, {
    $rateRewardPosition: getRewardPosition(rateRewardPosition),
    "data-testid": testID,
    $isReceivingRateReward: isReceivingRateReward,
    children: /*#__PURE__*/jsx(SvgIcon, {
      type: "gift",
      fill: meta === null || meta === void 0 ? void 0 : (_meta$colors = meta.colors) === null || _meta$colors === void 0 ? void 0 : _meta$colors.flamingo['1'],
      width: "10px",
      height: "10px"
    })
  });
};
const RateRewardSvgIconContainer = styled.div`
  position: absolute;
  top: -5.5px;
  left: ${props => (props === null || props === void 0 ? void 0 : props.$rateRewardPosition) || 0}%;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 24px;
  height: 24px;
  padding: 2px;
  background-color: ${props => {
  var _props$theme, _props$theme$colors;
  return (props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$colors = _props$theme.colors) === null || _props$theme$colors === void 0 ? void 0 : _props$theme$colors.gray['6']) || '#FAFAFA';
}};
  border: 3px solid
    ${props => {
  var _props$theme2, _props$theme2$colors, _props$theme3, _props$theme3$colors;
  return props.$isReceivingRateReward ? (props === null || props === void 0 ? void 0 : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : (_props$theme2$colors = _props$theme2.colors) === null || _props$theme2$colors === void 0 ? void 0 : _props$theme2$colors.flamingo['1']) || '#F65996' : (props === null || props === void 0 ? void 0 : (_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : (_props$theme3$colors = _props$theme3.colors) === null || _props$theme3$colors === void 0 ? void 0 : _props$theme3$colors.gray['5']) || '#F3F2F2';
}};
  border-radius: 50%;
  transform: translateX(-50%);
  pointer-events: none;
`;
RateReward.propTypes = {
  hideRateReward: PropTypes.bool,
  isReceivingRateReward: PropTypes.bool,
  rateRewardPosition: PropTypes.number.isRequired,
  testID: PropTypes.string
};
RateReward.defaultProps = {
  hideRateReward: false,
  isReceivingRateReward: false,
  testID: 'rate-reward'
};
var RateReward$1 = RateReward;

export { RateReward$1 as default };
//# sourceMappingURL=RateReward.js.map
